var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonDefault',{attrs:{"button-name":_vm.$t('shooting.buttons.download.download'),"outlined":true,"loading":_vm.loading},on:{"click":_vm.downloadVideo}})
}
var staticRenderFns = []

export { render, staticRenderFns }